import React from "react";
import { Props } from "./Props";

const FarmIcon: React.FC<Props> = ({ fill, otherProps }) => {
  const { width, height } = otherProps;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 67 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="41.3651"
        y="19.1786"
        width="13.35"
        height="12.3213"
        rx="1"
        fill={fill}
      />
      <path
        d="M66.4365 33.2899C64.7422 32.8361 62.6176 32.4373 60.1506 32.1729M7.66816 48.9186C10.8505 46.193 14.111 43.8709 17.3923 41.9007M18.9049 57.5723C24.2005 50.7698 41.1207 37.1647 66.4365 37.1647M37.6391 60.3885C44.9755 48.9189 58.3424 44.6561 63.8533 43.752C60.6401 49.2975 50.1671 60.5558 33.9807 61.2253C17.7943 61.8947 6.64671 49.3794 3.09622 43.038M0.563477 36.2235C4.7334 36.2678 13.9371 37.4653 17.3923 41.9007M17.3923 41.9007C22.0919 39.0788 26.8345 36.9787 31.4521 35.4484M0.563477 29.6417C2.37757 29.4793 4.85143 29.3859 7.66816 29.4598M31.4521 35.4484C30.2657 34.628 28.9571 33.9125 27.5647 33.2899M31.4521 35.4484C33.3028 34.8351 36.4315 33.7298 38.2312 33.2899M7.66816 29.4598V23.4665M7.66816 29.4598C10.8544 29.5434 14.4793 29.8412 18.0844 30.4955M7.66816 23.4665C4.04185 21.3237 1.64438 15.4255 7.66816 3.20471C10.4066 8.29725 14.0529 21.2902 7.66816 23.4665ZM18.0844 30.4955V24.5949M18.0844 30.4955C21.3777 31.0932 24.6544 31.9885 27.5647 33.2899M18.0844 24.5949C15.332 24.267 13.5874 20.1889 18.0844 9.50133C20.957 15.1903 21.8715 24.1413 18.0844 24.5949ZM27.5647 33.2899V13.8414L25.1107 17.6094L30.2618 9.68287L44.3102 1.74885L57.3867 9.68287L60.1506 13.6461M62.9146 17.6094L60.1506 13.6461M60.1506 13.6461V32.1729M60.1506 32.1729C57.3481 31.8725 54.1037 31.7457 50.5466 31.9091M38.2312 33.2899V22.0812H50.5466V31.9091M38.2312 33.2899C41.5896 32.4688 46.3703 32.1009 50.5466 31.9091"
        stroke="black"
        stroke-width="1.5"
      />
      <rect
        x="40.1206"
        y="9.09827"
        width="7.17237"
        height="7.17237"
        stroke="black"
        stroke-width="1.5"
      />
      <defs>
        <linearGradient
          id="paint0_linear_724_110"
          x1="48.0402"
          y1="19.1786"
          x2="48.0402"
          y2="31.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFA543" />
          <stop offset="1" stop-color="#FFCC83" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FarmIcon;
